import { render, staticRenderFns } from "./IgnitionChange.vue?vue&type=template&id=c5ab385e&"
import script from "./IgnitionChange.vue?vue&type=script&lang=js&"
export * from "./IgnitionChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports